@if (displayedItem()) {
  @if (mode === 'tab') {
    <div class="hr_poll hr_poll_tab" [class.below_tabs]="items().length > 1">
      <ng-container *ngTemplateOutlet="pollBody"></ng-container>
    </div>
  } @else {
    <div class="hr_strawpoll hr_poll">
      <div class="hr_collapsible_strawpoll" (click)="toggleExpanded()">
        <button type="button" class="hr_btn_collapsible">
          <span class="arrow" [ngClass]="{ active: expanded() }">
            <span></span>
            <span></span>
          </span>
          <span>{{ eLangGlob?.translatePollTitle }}</span>
          @if (hasNew()) {
            <span class="hr_poll_badge">{{ eLangGlob?.translatePollNew }}</span>
          }
        </button>
      </div>

      <div class="hr_collapsed_strawpoll" [@slideInOut]="expanded() ? 'in' : 'out'">
        <ng-container *ngTemplateOutlet="pollBody"></ng-container>
      </div>
      <hr />
    </div>
  }
} @else if (mode === 'tab') {
  <!-- Umfragen sind eingeschaltet, aber noch keine ist veröffentlicht -->
  <div class="hr_poll hr_poll_tab">
    <div class="hr_poll_body">
      <div class="hr_poll_empty" role="status">
        <svg class="hr_poll_empty_icon" viewBox="0 0 48 48" aria-hidden="true">
          <rect class="hr_poll_empty_bar" x="8" y="22" width="8" height="18" rx="2" style="--i: 0" />
          <rect class="hr_poll_empty_bar" x="20" y="12" width="8" height="28" rx="2" style="--i: 1" />
          <rect class="hr_poll_empty_bar" x="32" y="17" width="8" height="23" rx="2" style="--i: 2" />
        </svg>
        <div class="hr_poll_empty_title">{{ eLangGlob?.translatePollEmptyTitle }}</div>
        <p class="hr_poll_hint">
          {{ vod() ? eLangGlob?.translatePollVodEmptyText : eLangGlob?.translatePollEmptyText }}<span class="hr_poll_dots" aria-hidden="true"><span>.</span><span>.</span><span>.</span></span>
        </p>
      </div>
    </div>
  </div>
}

<ng-template #pollBody>
  <div class="hr_poll_body">
    <!-- Mehrere Einträge: Tabs, vorne der offene bzw. jüngste. Im Tab-Modus stehen sie im Seiten-Header.
         Eine Kette ist ein Eintrag; ihre Fragen blättert man im Karussell. -->
    @if (mode === 'panel' && items().length > 1) {
      <div class="hr_poll_tabs" role="tablist">
        @for (item of items(); track item.id) {
          <button
            type="button"
            role="tab"
            class="hr_poll_tabbtn"
            [class.active]="item.id === displayedItem()?.id"
            [attr.aria-selected]="item.id === displayedItem()?.id"
            [title]="item.kind === 'poll' ? text(item.poll, item.poll.question) : itemLabel(item)"
            (click)="selectItem(item)"
          >
            @if (itemOpen(item)) {
              <span class="hr_poll_livedot" aria-hidden="true"></span>
            }
            <span class="hr_poll_tablabel">{{ itemLabel(item) }}</span>
          </button>
        }
      </div>
    }

    @for (item of displayedList(); track item.id) {
      @if (item.kind === 'chain') {
        <ng-container *ngTemplateOutlet="chainCarousel; context: { $implicit: item }"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="pollCard; context: { $implicit: item.poll }"></ng-container>
      }
    }
  </div>
</ng-template>

<!-- Kette: Fragen nebeneinander, rasten beim Wischen ein; oben Pfeile und ein Punkt je Frage -->
<ng-template #chainCarousel let-item>
  @let focus = focused();
  @let index = focusIndex();
  <div class="hr_poll_chain">
    <div class="hr_poll_chain_nav">
      <button type="button" class="hr_poll_chain_arrow" [disabled]="index <= 0" (click)="goTo(item, index - 1)"
              [attr.aria-label]="eLangGlob?.translatePollPrev" [title]="eLangGlob?.translatePollPrev">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" /></svg>
      </button>
      <div class="hr_poll_series">
        <span>{{ focus ? seriesProgress(focus) : '' }}</span>
        <span class="hr_poll_series_dots">
          @for (step of seriesStepsOf(item); track step) {
            <button
              type="button"
              class="hr_poll_series_dot"
              [class.done]="seriesStepDone(item, step)"
              [class.current]="step === focus?.series?.index"
              [disabled]="!seriesStepVisible(item, step)"
              [style.--i]="step"
              [attr.aria-label]="seriesStepLabel(step, item)"
              (click)="goToSeriesStep(item, step)"
            ></button>
          }
        </span>
      </div>
      <button type="button" class="hr_poll_chain_arrow" [disabled]="index < 0 || index >= item.polls.length - 1" (click)="goTo(item, index + 1)"
              [attr.aria-label]="eLangGlob?.translatePollNextQuestion" [title]="eLangGlob?.translatePollNextQuestion">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" /></svg>
      </button>
    </div>
    <div class="hr_poll_chain_track" #track (scroll)="onTrackScroll(item, track)">
      @for (poll of item.polls; track poll.id) {
        <div class="hr_poll_chain_slide" [attr.inert]="poll.id !== focus?.id ? '' : null">
          <ng-container *ngTemplateOutlet="pollCard; context: { $implicit: poll }"></ng-container>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #pollCard let-poll>
  <div class="hr_poll_card">
    <h3 class="hr_poll_question">
      @if (poll.status === 'open') {
        <span class="hr_poll_live"><span class="hr_poll_livedot" aria-hidden="true"></span>{{ eLangGlob?.translatePollLive }}</span>
      } @else {
        <span class="hr_poll_closed">{{ eLangGlob?.translatePollEnded }}</span>
      }
      {{ text(poll, poll.question) }}
    </h3>
    @if (poll.status === 'open' && poll.type === 'multiple' && !myVote(poll)) {
      <p class="hr_poll_hint hr_poll_choice_hint">{{ maxChoicesHint(poll) }}</p>
    }

    @if (poll.status === 'open' && !myVote(poll)) {
      <!-- Abstimmen -->
      @if (poll.type === 'scale' && poll.scale) {
        <!-- Skala: Schieberegler ohne Vorauswahl, darunter die Werte zum Antippen -->
        @let value = scaleValue(poll);
        @let fill = scaleFill(poll, value);
        <div class="hr_poll_scale" [class.untouched]="value === null" [style.--p]="scaleFraction(poll, value)"
             [style.--lo]="fill.lo" [style.--hi]="fill.hi">
          <div class="hr_poll_scale_slider">
            <span class="hr_poll_scale_bubble" aria-hidden="true">{{ value }}</span>
            <input
              type="range"
              class="hr_poll_scale_range"
              step="1"
              [min]="poll.scale.min"
              [max]="poll.scale.max"
              [value]="value ?? scaleOrigin(poll)"
              [attr.aria-label]="text(poll, poll.question)"
              [attr.aria-valuetext]="value === null ? eLangGlob?.translatePollScaleHint : value"
              [disabled]="submitting() === poll.id"
              (input)="setScaleValue(poll, +$any($event.target).value)"
              (pointerup)="setScaleValue(poll, +$any($event.target).value)"
            />
          </div>
          <div class="hr_poll_scale_ticks">
            @for (tick of scaleValues(poll); track tick; let i = $index) {
              <button
                type="button"
                class="hr_poll_scale_tick"
                tabindex="-1"
                [class.selected]="tick === value"
                [style.--i]="i"
                [disabled]="submitting() === poll.id"
                (click)="setScaleValue(poll, tick)"
              >{{ tick }}</button>
            }
          </div>
          @if (text(poll, poll.scale.minLabel) || scaleMidLabel(poll) || text(poll, poll.scale.maxLabel)) {
            <div class="hr_poll_scale_labels">
              <span>{{ text(poll, poll.scale.minLabel) }}</span>
              <span class="mid">{{ scaleMidLabel(poll) }}</span>
              <span class="end">{{ text(poll, poll.scale.maxLabel) }}</span>
            </div>
          }
          @if (value === null) {
            <p class="hr_poll_hint hr_poll_scale_hint">{{ eLangGlob?.translatePollScaleHint }}</p>
          }
        </div>
      } @else if (poll.type === 'text') {
        <!-- Freie Antwort -->
        <div class="hr_poll_text">
          <textarea
            class="hr_poll_textarea"
            rows="3"
            [maxLength]="textLimit"
            [placeholder]="eLangGlob?.translatePollTextPlaceholder ?? ''"
            [attr.aria-label]="text(poll, poll.question)"
            [disabled]="submitting() === poll.id"
            [value]="textDraft()[poll.id] ?? ''"
            (input)="setText(poll, $any($event.target).value)"
          ></textarea>
          <div class="hr_poll_text_count" aria-hidden="true">{{ (textDraft()[poll.id] ?? '').length }} / {{ textLimit }}</div>
        </div>
      } @else {
        <div class="hr_poll_options" [attr.role]="poll.type === 'single' ? 'radiogroup' : 'group'">
          @for (option of poll.options; track option.id; let i = $index) {
            <div
              class="radioVote hr_poll_option"
              [class.multi]="poll.type === 'multiple'"
              [class.selected]="isSelected(poll, option.id)"
              [class.blocked]="isBlocked(poll, option.id)"
              [style.--i]="i"
            >
              <label>
                <input
                  [type]="poll.type === 'single' ? 'radio' : 'checkbox'"
                  [name]="'poll-' + poll.id"
                  [checked]="isSelected(poll, option.id)"
                  [disabled]="isBlocked(poll, option.id) || submitting() === poll.id"
                  (change)="toggle(poll, option.id)"
                />
                <span class="checkmark"></span>
                <span class="hr_radioButtonText">{{ text(poll, option.label) }}</span>
              </label>
            </div>
          }
        </div>
      }
      <div class="strawpoll_submit hr_poll_submit" [class.ready]="hasSelection(poll)">
        <span class="strawpoll_button_left"></span>
        <button
          type="button"
          class="hr_strawpoll_submit"
          [class.sending]="submitting() === poll.id"
          [disabled]="!hasSelection(poll) || submitting() === poll.id"
          (click)="submit(poll)"
        >
          {{ eLangGlob?.translateStrawpollClick }}
        </button>
        <span class="strawpoll_button_right"></span>
      </div>
      <!-- Überspringen wird mitgezählt; danach ist die Frage wie nach einer Stimme erledigt -->
      <div class="hr_poll_skip_row">
        <button type="button" class="hr_poll_skip" [disabled]="submitting() === poll.id" (click)="skip(poll)">
          {{ eLangGlob?.translatePollSkip }}
        </button>
      </div>
      @switch (outcome()[poll.id]) {
        @case ('closed') { <div class="ui visible warning message hr_poll_message">{{ eLangGlob?.translatePollClosed }}</div> }
        @case ('login') { <div class="ui visible warning message hr_poll_message">{{ eLangGlob?.translatePollError }}</div> }
        @case ('error') { <div class="ui visible warning message hr_poll_message">{{ eLangGlob?.translatePollError }}</div> }
      }
    } @else {
      <!-- Abgestimmt, übersprungen oder beendet -->
      @if (myVote(poll)?.skipped) {
        <div class="hr_poll_skipped">
          <svg class="hr_poll_skipped_icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h12M13 7l5 5-5 5" /></svg>
          <span>{{ eLangGlob?.translatePollSkipped }}</span>
        </div>
        @if (hasNextInSeries(poll)) {
          <div class="hr_poll_hint hr_poll_next">{{ eLangGlob?.translatePollSeriesNext }}</div>
        }
      } @else if (myVote(poll)) {
        <div class="hr_poll_thanks">
          <svg class="hr_poll_check" viewBox="0 0 52 52" aria-hidden="true">
            <circle cx="26" cy="26" r="24" />
            <path d="M15 27 l7 7 l15 -15" />
          </svg>
          <div>
            <div class="hr_poll_thanks_title">{{ eLangGlob?.translatePollThanks }}</div>
            <div class="hr_poll_hint hr_poll_mine_line">
              {{ poll.type === 'text' ? eLangGlob?.translatePollYourAnswer : eLangGlob?.translateChoice }}: <strong>{{ chosenLabels(poll) }}</strong>
            </div>
            @if (hasNextInSeries(poll)) {
              <div class="hr_poll_hint hr_poll_next">{{ eLangGlob?.translatePollSeriesNext }}</div>
            }
          </div>
        </div>
      }

      @if (showResults(poll)) {
        @if (poll.type === 'scale' && poll.scale) {
          <!-- Skala: Durchschnitt mit seiner Lage auf der Skala, darunter die Verteilung -->
          @let avg = average(poll);
          <div class="hr_poll_scale_result">
            <div class="hr_poll_average">
              @if (avg !== null) {
                <span class="hr_poll_average_value" [lseCountUp]="avg" [lseCountUpDecimals]="1" [lseCountUpLocale]="lang()"></span>
              } @else {
                <span class="hr_poll_average_value">–</span>
              }
              <span class="hr_poll_average_caption">{{ eLangGlob?.translatePollAverage }}</span>
            </div>
            @let avgFill = scaleFill(poll, avg);
            <div class="hr_poll_average_track" [class.empty]="avg === null" [style.--p]="scaleFraction(poll, avg)"
                 [style.--lo]="avgFill.lo" [style.--hi]="avgFill.hi">
              <span class="hr_poll_average_fill"></span>
              <span class="hr_poll_average_marker"></span>
            </div>
            <div class="hr_poll_average_ends">
              <span>{{ poll.scale.min }}@if (text(poll, poll.scale.minLabel)) { · {{ text(poll, poll.scale.minLabel) }} }</span>
              <span class="mid">{{ scaleMidLabel(poll) }}</span>
              <span class="end">@if (text(poll, poll.scale.maxLabel)) { {{ text(poll, poll.scale.maxLabel) }} · }{{ poll.scale.max }}</span>
            </div>

            @if (!showAverageOnly(poll)) {
              <div class="hr_poll_histogram" role="list">
                @for (column of rows(poll); track column.id; let i = $index) {
                  <div
                    class="hr_poll_column"
                    role="listitem"
                    [class.mine]="column.mine"
                    [class.leader]="column.leader"
                    [style.--i]="i"
                    [attr.aria-label]="column.label + ': ' + column.percent + ' %'"
                  >
                    <span class="hr_poll_column_value">@if (column.count) { {{ column.percent }}% }</span>
                    <span class="hr_poll_column_bar"><span class="hr_poll_column_fill" [style.height.%]="column.height"></span></span>
                    <span class="hr_poll_column_label">{{ column.label }}</span>
                  </div>
                }
              </div>
            }
            <p class="hr_poll_hint hr_poll_total">
              <span [lseCountUp]="poll.results?.voterCount ?? 0"></span> {{ eLangGlob?.translatePollVotes }}
            </p>
          </div>
        } @else if (showDonut(poll)) {
          <!-- Endergebnis als Kreisdiagramm -->
          @let segments = donut(poll);
          <div class="hr_poll_donut_wrap">
            <svg class="hr_poll_donut" viewBox="0 0 100 100" role="img" [attr.aria-label]="eLangGlob?.translateResult">
              <circle class="hr_poll_donut_track" cx="50" cy="50" r="40" />
              <g class="hr_poll_donut_segments">
                @for (segment of segments; track segment.id; let i = $index) {
                  <circle
                    class="hr_poll_donut_seg"
                    cx="50"
                    cy="50"
                    r="40"
                    [style.stroke]="segment.color"
                    [attr.stroke-dasharray]="segment.dash"
                    [attr.stroke-dashoffset]="segment.offset"
                    [style.--i]="i"
                  />
                }
              </g>
              <text class="hr_poll_donut_total" x="50" y="46" [lseCountUp]="poll.results?.voterCount ?? 0"></text>
              <text class="hr_poll_donut_caption" x="50" y="65">{{ eLangGlob?.translatePollVotes }}</text>
            </svg>
            <ul class="hr_poll_legend">
              @for (segment of segments; track segment.id; let i = $index) {
                <li [class.mine]="segment.mine" [class.leader]="segment.leader" [style.--i]="i">
                  <span class="hr_poll_swatch" [style.background]="segment.color"></span>
                  <span class="hr_poll_legend_label">{{ segment.label }}</span>
                  <span class="hr_poll_result_value"><span [lseCountUp]="segment.percent"></span> %</span>
                </li>
              }
            </ul>
          </div>
        } @else {
          <!-- Balken: live mitlaufend, am Ende mit hervorgehobener führender Antwort -->
          <div class="hr_poll_results">
            @for (row of rows(poll); track row.id; let i = $index) {
              <div class="hr_poll_result" [class.mine]="row.mine" [class.leader]="row.leader" [style.--i]="i">
                <div class="hr_poll_result_label">
                  <span>{{ row.label }}@if (row.mine) { <span class="hr_poll_mine" aria-hidden="true">✓</span> }</span>
                  <span class="hr_poll_result_value"><span [lseCountUp]="row.percent"></span> %</span>
                </div>
                <div class="hr_poll_bar"><div class="hr_poll_bar_fill" [style.width.%]="row.percent"></div></div>
              </div>
            }
            <p class="hr_poll_hint hr_poll_total">
              <span [lseCountUp]="poll.results?.voterCount ?? 0"></span> {{ eLangGlob?.translatePollVotes }}
            </p>
          </div>
        }
      } @else if (poll.resultsVisibility === 'onPublish') {
        <p class="hr_poll_pending">
          {{ vod() ? eLangGlob?.translatePollVodResultLater : eLangGlob?.translateStrawpollResultDefer }}<span class="hr_poll_dots" aria-hidden="true"><span>.</span><span>.</span><span>.</span></span>
        </p>
      } @else if (poll.status === 'closed' && !myVote(poll)) {
        <p class="hr_poll_hint">{{ eLangGlob?.translatePollClosed }}</p>
      }
    }
  </div>
</ng-template>
